module.exports = __webpack_public_path__ + "images/estimateform_bg_sp_60e7d19cfbb70c9fd8cae8f573ca6c2a.png";